import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { FontStyles } from "../utils/font-styles.ts";
import { ButtonLink } from "../components/buttons/button-link.tsx";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";
import { TrackEvent } from "../utils/analytics.ts";
import { BookingButton } from "./components/booking-button.tsx";
import { cn } from "../utils/cn.ts";

const componentContainer = "flex flex-col gap-3 md:gap-3.5 w-full";
const titleStyle = `text-north-sea font-medium ${FontStyles.h5}`;
const buttonContainer = "flex flex-col md:flex-row gap-3 md:gap-4 self-stretch w-full";
const buttonStyle = "flex w-full flex-col";

export const BookViewing = () => {
  const { agentPhone, viewingDescription } = usePropertyDetailsContext();
  return (
    <div className={componentContainer}>
      <h2 className={titleStyle}>Book a viewing</h2>
      {viewingDescription && <p className={cn(FontStyles["body-md"], "text-slate")}>{viewingDescription}</p>}
      <div className={buttonContainer}>
        <div className={buttonStyle}>
          <BookingButton />
        </div>
        {agentPhone && (
          <div className={buttonStyle}>
            <ButtonLink
              label="Call agent"
              colorVariant="secondary"
              variant="outlined"
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-phone" />}
              href={`tel:${agentPhone}`}
              onClick={() => TrackEvent({ name: "agent_phone_link_click", value: 10 })}
            />
          </div>
        )}
      </div>
    </div>
  );
};
